export const textConfigs = {
    startText: 'Налоговый расчет',
    titlePanel: 'Налоговый вычет',
    hintPanlel: 'Используйте налоговый вычет чтобы погасить ипотеку досрочно. Размер налогового вычета составляет не более 13% от своего официального годового дохода.',
    yourSalaryPanel: 'Ваша зарплата',
    hintInputPanel: 'Введите данные',
    calculatePanel: 'Рассчитать',
    tagsQuestionPanel: 'Что уменьшаем?',
    errorInput: 'Поле обязательно для заполнения',
    errorInputCount: 'Не может быть выше 260000',
    addPanel: 'Добавить',
}